import { useEffect, useState } from 'react';

export interface CountdownValue {
  hours: number;
  minutes: number;
  seconds: number;
  done: boolean;
}

export function useCountdown(targetMs: number | null): CountdownValue {
  const [remain, setRemain] = useState<number>(() =>
    targetMs ? Math.max(0, targetMs - Date.now()) : 0,
  );

  useEffect(() => {
    if (!targetMs) {
      setRemain(0);
      return undefined;
    }
    const tick = () => setRemain(Math.max(0, targetMs - Date.now()));
    tick();
    const timer = window.setInterval(tick, 1000);
    return () => window.clearInterval(timer);
  }, [targetMs]);

  const total = Math.max(0, remain);
  return {
    hours: Math.floor(total / 3600000),
    minutes: Math.floor((total % 3600000) / 60000),
    seconds: Math.floor((total % 60000) / 1000),
    done: total <= 0,
  };
}